import { customElement, property } from 'lit/decorators.js';
import type { EmployeeForStaffingCalendar } from 'src/store/selectors';
import { DSelectDate } from '../library/editors/elements/d-select-date.js';

type EmployeeEmploymentPeriod = Pick<EmployeeForStaffingCalendar, 'employmentStartDate' | 'employmentEndDate'>;

@customElement('d-select-employment-date')
export class DSelectEmploymentDate extends DSelectDate {
  @property({ type: Object })
  employee?: EmployeeEmploymentPeriod;

  protected willUpdate(changedProperties: Map<PropertyKey, unknown>) {
    super.willUpdate(changedProperties);
    this.disableBefore = this.employee?.employmentStartDate ?? '';
    this.disableAfter = this.employee?.employmentEndDate ?? '';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-select-employment-date': DSelectEmploymentDate;
  }
}
